import styled, { css } from 'styled-components';
import { spaceOptions, depreciateComponent } from './utils';
import { transparentize, desaturate } from 'polished';

const center = css`
  ${props =>
    props.center &&
    css`
      text-align: center;
    `};
`;
const Types = ['primary', 'secondary'];

const responsiveBg = ({ theme, background }) => {
  if (typeof background === 'string') {
    return css`
      background-image: url(${background});
    `;
  }
  if (typeof background === 'object') {
    return css`
      ${background.xs &&
        css`
          background-image: url(${background.xs});
        `} ${background.sm &&
          css`
            @media (min-width: ${theme.breakpoints.sm}rem) {
              background-image: url(${background.sm});
            }
          `} ${background.md &&
          css`
            @media (min-width: ${theme.breakpoints.md}rem) {
              background-image: url(${background.md});
            }
          `} ${background.lg &&
          css`
            @media (min-width: ${theme.breakpoints.lg}rem) {
              background-image: url(${background.lg});
            }
          `};
    `;
  }
};

const getColorFromProps = props => {
  return props.theme[Types.find(type => Object.keys(props).indexOf(type) > -1)] || props.theme.dark;
};

const getBgColorFromProps = props => {
  return props.theme[Types.find(type => Object.keys(props).indexOf(type) > -1)] || props.theme.snow;
};

export const Card = styled.div`
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '10px')};
  background: ${props => props.theme.defaultBackground};
  padding: 20px;
  width: 100%;
  margin-top: 20px;
  ${spaceOptions} ${props =>
      props.dark &&
      css`
        background: ${props.theme.dark};
        color: #fff;
      `} ${props =>
      props.snow &&
      css`
        background: ${props.theme.snow};
        color: ${props.theme.darkgray};
      `};

  ${center};
`;

Card.displayName = 'Card';

const CardSection = styled.div`
  color: ${props => desaturate(0.4, getColorFromProps(props)) || desaturate(0.4, props.theme.dark)};
  background-color: ${props =>
    transparentize(0.95, getBgColorFromProps(props)) || transparentize(0.95, props.theme.snow)};
  box-shadow: 0 1px 0 0
    ${props =>
      transparentize(0.7, getColorFromProps(props)) || transparentize(0.7, props.theme.muted)};
  ${spaceOptions};
  ${center};
`;
Card.Section = CardSection;
Card.Section.displayName = 'Card.Section';

export const CardHeading = depreciateComponent(
  '<CardHeading /> is depreciated!, please use <Card.Section /> instead!'
)(CardSection);
CardHeading.displayName = 'CardHeading';

export const Jumbotron = styled.div`
  ${props => responsiveBg(props)} text-align: left;
  background-position: 50%;
  background-size: cover;
  position: relative;
  color: #fff;
  margin-bottom: 0;
  zoom: 1;
  padding: 30px 10px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    padding: 30px;
  }
  background-color: #eee;
  &:before {
    content: '';
    display: block;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  .mobile {
    padding-left: 20px;
    li {
      font-size: 16px;
      list-style: none;
      height: 40px;
      vertical-align: middle;
      .words-wrapper {
        position: relative;
        min-width: 190px;
        .words {
          top: 3px;
          left: 35px;
          position: absolute;
        }
      }
      .circle-wrapper {
        float: left;
        .circle {
          vertical-align: middle;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          position: relative;
          display: inline-block;
          border: 1px solid #ffffff;
          margin-right: 10px;
          div {
            position: absolute;
            font-size: 16px;
            top: 2px;
            left: 9px;
          }
        }
      }
    }
  }
  .list-box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    .list-block {
      float: left;
      width: 150px;
      text-align: center;
      .circle {
        vertical-align: middle;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        border: 1px solid #ffffff;
        margin-left: 60px;
        margin-bottom: 10px;
        position: relative;
        text-align: center;
        div {
          position: absolute;
          font-size: 16px;
          top: 2px;
          left: 9px;
        }
      }
      .list-text {
        width: 150px;
        text-align: center;
      }
    }
    .list-hr {
      width: 80px;
      text-align: center;
    }
  }
`;

export const StatusCard = styled.div`
  background: #ccc;
  width: 100%;
  padding: 0 20px;
  ${props =>
    props.side &&
    css`
      background: ${props.theme.back};
      color: #fff;
      font-size: 14px;
      height: 88px;
      @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
        font-size: 16px;
      }
      @media (min-width: ${props => props.theme.breakpoints.md}rem) {
        height: 68px;
      }
      span {
        padding: 0px 20px;
        margin-top: 20px;
        margin-bottom: 10px;
        display: inline-block;
      }
    `} ${props =>
      props.main &&
      css`
        background: ${props.theme.back};
        color: #fff;
        font-size: 20px;
        text-align: left;
        height: 58px;
        @media (min-width: ${props => props.theme.breakpoints.md}rem) {
          height: 68px;
          padding-right: 20px;
          text-align: right;
          font-size: 20px;
          background: ${props.theme.primary};
        }
        @media (min-width: ${props => props.theme.breakpoints.lg}rem) {
          height: 68px;
          padding-right: 60px;
          text-align: right;
          font-size: 20px;
          background: ${props.theme.primary};
        }
        span {
          padding: 0px 10px;
          margin-top: 10px;
          margin-bottom: 10px;
          display: inline-block;
          @media (min-width: ${props => props.theme.breakpoints.md}rem) {
            margin-top: 20px;
            padding: 0px 20px;
          }
        }
      `};
  img {
    vertical-align: middle;
    margin-right: 10px;
    margin-bottom: 10px;
    @media (min-width: ${props => props.theme.breakpoints.md}rem) {
      margin-bottom: 0px;
    }
  }
  ${spaceOptions};
`;

export const SpotsCard = styled.div`
  padding: 0px;
  width: 100%;
  height: 150px;
  text-align: center;
  vertical-align: middle;
  img {
    width: 80px;
    height: 80px;
    margin-bottom: 5px;
    border-radius: 50%;
  }
  .title {
    width: 100%;
    font-size: 16px;
    line-height: 20px;
    vertical-align: middle;
    color: #2f3034;
    font-weight: 600;
  }
  a {
    color: #7b7c7e;
    text-decoration: none;
    font-weight: 400;
    line-height: 26px;
    display: inline-block;
  }
  ${spaceOptions};
`;

export const BusinessCard = styled.a`
  padding: 0px;
  height: 100px;
  width: 100%;
  border: 1px solid #d9dada;
  border-radius: 10px;
  background-color: #ffffff;
  margin-bottom: 10px;
  margin-top: 10px;
  display: table;
  vertical-align: middle;
  text-decoration: none;
  img {
    width: 70px;
    margin-top: 25px;
    margin-left: 18px;
    margin-right: 0px;
  }
  .title {
    text-align: left;
    width: 100%;
    font-size: 16px;
    line-height: 22px;
    display: table-cell;
    vertical-align: middle;
    padding-left: 20px;
    padding-right: 5px;
    color: #434447;
    .subtitle {
      font-weight: 600;
      line-height: 18px;
    }
  }
  ${spaceOptions};
`;
